module.exports = __webpack_public_path__ + "static/media/API_observer.9468d86f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/developerApi/developerSdk/Documentation/IOS/images/API_observer.jpg
// module id = 1164
// module chunks = 0